/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';

  /**
   * Вид для формы пользовательских данных в кабинете.
   */
  app.UserDataNewFormView = app.FormView.extend({
    el: '#user-data-form',
    fileTypes: ['image/jpg', 'image/jpeg', 'image/png', 'image/gif'],
    successContactList: false,
    successUserData: false,
    currentLenghtNameFile: 15,
    isUploadPhoto: false,
    imageBlob: null,
    formName: 'user-data',

    events: {
      'click .update-user-data-button': 'save',
      'click #cancel': 'cancel',
      'click .js-add-contact-info': 'appendContact',
      'input #photo': 'changeImage',
    },

    run: function () {
      app.FormView.prototype.run.apply(this, arguments);
      this.uploadOptions = _.extend(this.uploadOptions, {
        urlRoot: '/api/v3/user/' + this.user.id + '/',
      });

      this.$fields = this.$el.find('.field');
      this.initMainPhoneMask();

      this.userContactListView = new app.UserDataContactListView({
        collection: this.collection,
        el: this.$el.find('.inputs'),
      });

      this.userContactListView.on(
        'success-user-data-contact-list-view',
        this.toggleOnSuccessContactList,
        this
      );

      this.userContactListView.on(
        'error-user-data-contact-list-view',
        this.negateSuccessContactList,
        this
      );
      this.fillFields();
      this.checkForMobile();
    },

    /**
     * Инициализирует маски телефонов
     */
    initMainPhoneMask: function () {
      var input = $('#phone'),
        model = app.countryFlag.clone(),
        number = '';
      number = number || input.val();
      model.unset('id').set(app.helpers.PhoneHelper.getCountryCodeFromNumber(number));
      new app.ChoiceCountryView({ el: input.siblings('.choice-country'), model: model });
      this.mainPhoneInputMask = new app.PhoneInputmaskView({ el: input, model: model });
    },

    toggleOnSuccessContactList: function () {
      this.successContactList = true;
      this.toggleOnSuccess();
    },

    negateSuccessContactList: function () {
      this.successContactList = false;
      this.$('.update-user-data-button').prop('disabled', false);
    },

    /**
     * Мигание только если произошло три события:
     * - Успешно обновлены телефоны
     * - Успешно сохранены данные пользователя
     * - Успешно обновлено фото профиля
     */
    toggleOnSuccess: function () {
      var isSuccess;
      if (this.isUploadPhoto) {
        isSuccess = this.successUserData && this.successContactList && this.successUserPhoto;
      } else {
        isSuccess = this.successUserData && this.successContactList;
      }
      if (isSuccess) {
        this.successUserData = false;
        this.successContactList = false;
        this.successUserPhoto = false;
        this.isUploadPhoto = false;
        this.toggle();
        this.trigger('success-user-data-form');
      }
      this.$('.update-user-data-button').prop('disabled', false);
    },

    /**
     * Добавляет новый контакт пользователя
     */
    appendContact: function () {
      this.userContactListView.addContact();
    },

    /**
     * Сохраняет данные в модель this.user
     *
     * @param e Объект события
     */
    save: function (e) {
      var attributes = {};

      // делаем кнопку отключенной
      $(e.currentTarget).prop('disabled', true);

      // сохраняем все данные из полей
      this.$fields.each(function () {
        var type = $(this).attr('type');

        // если тип поля text или tel
        if (_.includes(['text', 'tel'], type)) {
          attributes[this.name] = $(this).val();
        } else if (type === 'checkbox') {
          attributes[this.name] = $(this).prop('checked');
        }
      });
      // attributes.birth_date = $('#birth_year').val() + '-' + $('.birth_month:checked').val() + '-' + $('#birth_day').val();

      // сохраняем текущий список параметров запроса
      var oldExpand = this.user.expand;

      // определяем параметр запроса для проверки согласия на обработку данных
      this.user.expand = $.param({
        'features': 'accept_agreement',
      });

      // сохраняем модель
      this.user.save(attributes, {
        'success': this.success.bind(this),
        'error': this.error.bind(this),
        'wait': true,
      });

      // возвращаем сохраненный список параметров
      this.user.expand = oldExpand;

      if (this.imageBlob && this.imageBlob instanceof Blob) {
        var formData = new FormData();
        this.headerUpload = { "X-HTTP-Method-Override": "PUT" };
        formData.append('photo', this.imageBlob, this.imageBlob.name);
        app.FormView.prototype.postFormData.apply(this, [formData]);
      }
    },

    /**
     * Сохранение контактов.
     */
    saveContacts: function () {
      this.userContactListView.save();
      this.mainPhoneInputMask.save();
      this.checkForMobile();
    },

    /**
     * Выполняется в случае успешного сохранения модели user
     */
    success: function () {
      this.successUserData = true;
      this.saveContacts();
      this.toggleOnSuccess();
      this.clearErrors();
    },

    /**
     * Выполняется в случае ошибки при сохранении модели user
     * @param {Object} model Модель
     * @param {Object} response Объект ответа
     */
    error: function (model, response) {
      if (response) {
        this.successUserData = false;
        if (response.status === 422) {
          var errors;
          try {
            errors = JSON.parse(response.responseText);
          } catch (error) {
            errors = [];
          }
          if (Array.isArray(errors)) {
            this.clearErrors();
            errors.forEach(function (error) {
              this.$('#' + error.field + '-error').text(error.message);
              this.$('#' + error.field).addClass('error');
            }.bind(this));
          }
        } else {
          app.helpers.ErrorHelper.globalValidationError([{
            message: response.responseText,
          }], 'При сохранении личных данных');
        }
      }
      this.$('.update-user-data-button').prop('disabled', false);
    },

    /**
     * Скрывает сообщения об ошибках и убирает соответствующие классы у полей
     */
    clearErrors: function (name) {
      if (name) {
        this.$('#' + name + '-error').text('');
      } else {
        app.FormView.prototype.clearErrors.apply(this);
      }
    },

    /**
     * Заполняет поля данными из моделей
     */
    fillFields: function () {
      var code = app.countryFlag.get('code') || '+7';

      this.$fields.each(function (index, el) {
        var value = this.user.get(el.name);

        if (value && (el.name !== 'phone' || value.indexOf(code.replace('+', '')) === 0)) {
          $(el).val(value);
        }
        if (el.name === 'photo') {
          $(el).val('');
          this.imageBlob = null;
          this.$('.b-avatar_small').attr('src', this.user.get('photo_url'));
          this.$('.file-name').text('');
        }
      }.bind(this));
    },

    /**
     * Скрывает форму изменения личных данных
     */
    cancel: function () {
      this.toggle();
      this.trigger('cancel-user-data-form');
      this.fillFields();
      this.clearErrors();
      this.userContactListView.restore();
    },

    /**
     * Проверяет данные, введенные в поле на номер мобильного телефона
     */
    checkForMobile: function () {
      var input = this.$('.input_4').first(),
        code = app.countryFlag.get('code') || '+7',
        start = code.length - 1,
        end = start + 3,
        phoneCode = parseInt(input.val().substring(start, end)),
        phoneNumberLength = input.val().length,
        checkForMobile = app.helpers.isMobileHelper.isMobile(phoneCode, phoneNumberLength);
      if (checkForMobile) {
        input.parent().siblings('.can-restore').show();
      } else {
        input.parent().siblings('.can-restore').hide();
      }
    },

    /**
     * Обработка выбранной картинки.
     * @param {InputEvent} event Событие изменения поля формы.
     */
    changeImage: function(event) {
      if (event.target.files && event.target.files[0]) {
        var imageBlob = event.target.files[0];
        if (this.fileTypes.indexOf(imageBlob.type) > -1) {
          var image = new Image();
          image.onload = function () {
            if (image.width <= 95 || image.height <= 95) {
              this.fillErrors([{
                field: 'photo',
                message: 'Изображение не должно быть меньше 95 × 95px.'
              }]);
            } else {
              this.clearErrors();
              this.cropUserPhoto(image, imageBlob.name);
            }
          }.bind(this);
          image.src = URL.createObjectURL(imageBlob);
        } else {
          this.fillErrors([{
            field: 'photo',
            message: 'Доступные форматы изображения: jpeg, jpg, png, gif'
          }]);
        }
      }
    },

    /**
     * Обрезать аватарку
     * @param {HTMLImageElement} imageElem Изображение.
     * @param {string} blobFileName Название файла.
     */
    cropUserPhoto: function(imageElem, blobFileName) {
      var options = { width: 200, height: 200 };
      smartcrop.crop(imageElem, options).then(function(result) {
        var crop = result.topCrop,
          canvas = document.createElement('canvas'),
          ctx = canvas.getContext('2d');
        canvas.width = options.width;
        canvas.height = options.height;
        ctx.drawImage(imageElem, crop.x, crop.y, crop.width, crop.height, 0, 0, canvas.width, canvas.height);
        canvas.toBlob(function (blob) {
          this.imageBlob = blob;
          this.imageBlob.name = blobFileName;
          this.addPreviewUploadImage(canvas.toDataURL('image/png'));
        }.bind(this));
      }.bind(this));
    },

    /**
     * Создать превью картинки.
     * @param {string} data Ссылка на blob ужатой картинки.
     */
    addPreviewUploadImage: function (data) {
      var fileName = this.imageBlob.name;
      this.$('#avatar_img').attr('src', data);
      this.$('#avatar_img').removeClass('not_display');
      if (!this.$('#avatar_default').hasClass('not_display')) {
        this.$('#avatar_default').addClass('not_display');
      }
      if (fileName && fileName.length > this.currentLenghtNameFile) {
        fileName = '...' + fileName.substr(fileName.length - this.currentLenghtNameFile);
      }
      this.$('.file-name').text(fileName);
    },

    /**
     * Ошибка отправки аватарки
     * @param error
     * @param formData
     * @private
     */
    _uploadError: function (error, formData) {
      this.error(formData, error);
    },

    /**
     * Обработка успешного изменения изображения пользователя.
     * @param {Object} response Ответ с сервера после сохранения изображения.
     * @private
     */
    _uploadSuccess: function (response) {
      this.successUserPhoto = true;
      this.user.set({
        photo_url: response.photo_url,
        photo_filename: response.photo_filename,
      });
      this.toggleOnSuccess();
      this.clearErrors('photo');
    }
  });
})(jQuery);

}.call(window));